/**
 *
 * Login
 *
 */

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { FormattedMessage } from "react-intl";
import { compose } from "redux";
import messages from "./messages";

import { Container, Row } from "reactstrap";
import { Link, Redirect, Route, Switch } from "react-router-dom";
import HomePage from "../Home/Loadable";
import Settings from "../Settings/Loadable";
import Pickups from "../Pickups/Loadable";
import Pickup from "../Pickup/Loadable";
import LoginLayout from "components/LoginLayout";
import LoginSendCode from "forms/donor-login-sendCode/";
import LoginCode from "forms/donor-login-code/";
import { SquareButton } from "../Home";
import { forgotPassword } from "api/auth";

import "./styles.scss";

/* eslint-disable react/prefer-stateless-function */
export class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      phoneNumber: undefined,
    };
  }

  setPhoneNumber = (phoneNumber) => {
    this.setState({ phoneNumber: phoneNumber });
  };

  clearPhoneNumber = () => {
    this.setState({ phoneNumber: undefined });
  };

  handleSendByEmail = () => {
    forgotPassword({
      phoneNumber: this.state.phoneNumber,
      isSendingByEmail: true,
    })
      .then((response) => {
        const {
          data: { email },
        } = response;
        this.setState({
          errorSendingByEmail: false,
          sentCodeByEmail: true,
          email,
        });
      })
      .catch((err) => {
        this.setState({ sentCodeByEmail: false, errorSendingByEmail: true });
      });
  };

  render() {
    const { sentCodeByEmail, errorSendingByEmail, email, phoneNumber } =
      this.state;
    return (
      <LoginLayout>
        <div>
          <Helmet>
            <title>LoginPage</title>
            <meta name="description" content="Description of LoginPage" />
          </Helmet>
          <div className="center">
            <img
              style={{ maxWidth: "100%" }}
              src={`${
                process.env.REACT_APP_LOGIN_LOGO_URL ||
                process.env.REACT_APP_LOGO_URL
              }`}
            />
            {/*<div className={'p-3'}>*/}
            {/*  <h4>Pickup Donation Login</h4>*/}
            {/*  <i>Forgot Password</i>*/}
            {/*</div>*/}
          </div>
          {!this.state.phoneNumber ? (
            <div>
              <div>
                Please Enter the phone number associated with your account to be
                sent an access code.
                <br />
                <br />
                If you can't receive text messages, give us a call at{" "}
                {process.env.REACT_APP_CONTACT_PHONE_NUMBER} to access your
                account.
              </div>
              <br />
              <LoginSendCode onSubmitSuccess={this.setPhoneNumber} />
            </div>
          ) : (
            <div>
              <LoginCode
                phoneNumber={phoneNumber}
                email={email}
                sentCodeByEmail={sentCodeByEmail}
                errorSendingByEmail={errorSendingByEmail}
                onSubmitSuccess={() => {
                  this.props.history.push(`/settings/password`);
                }}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "baseline",
                }}
              >
                <div className={"right pt-3"}>
                  <a
                    href={"#"}
                    onClick={() => {
                      this.clearPhoneNumber();
                    }}
                  >
                    {" "}
                    Go Back
                  </a>
                </div>
                <p
                  className="code-email-link"
                  onClick={() => this.handleSendByEmail()}
                >
                  Use Email Instead
                </p>
              </div>
            </div>
          )}
        </div>
        <br />
        Know your password?
        <Link to="/login"> Login</Link>
      </LoginLayout>
    );
  }
}

Login.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

const withConnect = connect(null, mapDispatchToProps);

export default compose(withConnect)(Login);
